import { FILTERS } from './evidenceFilters';

export default {
  path: '/evidences/all',
  filters: FILTERS,
};
